import { RESET_ALERT } from '../actionTypes';
import { alertsActions } from '../reducer';

export default () => alertsActions[RESET_ALERT]();
